export default "__VITE_ASSET__C3A6k9L4__"